import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowId, WorkflowInstanceId} from "common/flowmaster/types/workflow";

export type WorkflowInstanceUpdateIsArchivedAction = {
  type: WorkflowsActionTypes["WORKFLOW_INSTANCE_UPDATE_IS_ARCHIVED"]["SUCCESS"];
  payload: {
    workflow_id: WorkflowId;
    workflow_instance_id: WorkflowInstanceId;
    is_archived: boolean;
  };
};

export default function updateWorkflowInstanceIsArchived(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_INSTANCE_UPDATE_IS_ARCHIVED,
    (
      organisationId: OrganisationId,
      workflowId: WorkflowId,
      workflowInstanceId: WorkflowInstanceId,
      isArchived: boolean,
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/workflow/${workflowId}/workflow_instance/${workflowInstanceId}/archive`,
          {
            is_archived: isArchived,
          },
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
